export function fromEpochTime(epochTime: number) {
  return epochTime * 1000 + 1515931200000 - 500;
}

export function formatTimestamp(timestamp: number) {
  const date = new Date(fromEpochTime(timestamp));
  return date.toLocaleString();
}
